/* eslint-disable no-unused-vars */
type ImageTesterType<T, F = any> = {
  catch<TResult = never>(
    onrejected?:
      | ((reason: F) => TResult | PromiseLike<TResult>)
      | undefined
      | null
  ): Promise<T | TResult>;
} & Promise<T>;

export const imageTester = (
  url: string
): ImageTesterType<string, undefined> => {
  return new Promise((resolve, reject) => {
    const imageElement = new Image();

    imageElement.addEventListener("load", () => {
      resolve(url);
    });

    imageElement.addEventListener("error", () => {
      reject();
    });

    imageElement.src = url;
  });
};
